import { useDispatch, useSelector } from 'react-redux'
import { OrganizationsListResponse } from 'src/models/organizations.models'
import { MutationMethod, useExtendMutation } from 'src/queries/queries.utils'
import {
  GET_ORGANIZATION_FAILURE,
  GET_ORGANIZATION_INIT,
  GET_ORGANIZATION_SUCCESS,
} from 'src/redux/actions/data/organizations.actions'
import { selectUserExplicitOrganizationListModelFromState } from 'src/redux/selectors/data/organizations.selectors'

interface PutOrgReceiptVerificationEnabledBody {
  enabled: boolean
}

interface UsePutOrgReceiptVerificationEnabledRequest {
  id: string
  body: PutOrgReceiptVerificationEnabledBody
}

export const usePutOrgReceiptVerificationEnabled = () => {
  const dispatch = useDispatch()

  return useExtendMutation<
    OrganizationsListResponse,
    UsePutOrgReceiptVerificationEnabledRequest
  >(MutationMethod.PUT, {
    mutationUrl: ({ id }) => `/organizations/${id}/receiptverification`,
    reduxInitAction: { type: GET_ORGANIZATION_INIT },
    onSuccess: (data) => {
      dispatch({
        type: GET_ORGANIZATION_SUCCESS,
        payload: { organization: data },
      })
    },
    onError: (error) => {
      dispatch({ type: GET_ORGANIZATION_FAILURE, payload: error })
    },
  })
}

/**
 * Returns whether the receipt-verification feature is enabled for the current
 * org. The org-level toggle is the source of truth; the remote config flag is
 * no longer consulted.
 */
export const useReceiptVerificationEnabled = (): boolean => {
  const org = useSelector(selectUserExplicitOrganizationListModelFromState)
  return org?.receiptVerificationEnabled ?? false
}
